import { appServe } from "@/service";
import { defineStore } from "pinia";
// import { areaLabelHandler, peopleLabelHandler } from "@/utils/dataHanler";
const areaLabelHandler = () => {};
const peopleLabelHandler = () => {};

export const useAppStore = defineStore("app", {
  state: () => ({
    areaLabels: null,
    peopleLabels: null,
    areaPickList: [],
  }),
  actions: {
    async queryPeopleLabel() {
      const data = await appServe.queryPeopleLabel();
      if (data.success) {
        this.peopleLabels = peopleLabelHandler(data.result);
      }
      return data.success;
    },

    async queryAreaLabel() {
      const data = await appServe.queryAreaLabel();
      if (data.success) {
        const { areaLabels, areaPicker } = areaLabelHandler(data.result);
        this.areaLabels = areaLabels;
        this.areaPickList = areaPicker;
      }
      return data.success;
    },
  },
});
